import React from "react";
import { Link } from "react-router-dom";
import heroMatchup from "../../assets/images/hero-matchup.jpg";
import { Container } from "react-bootstrap";

const HeroSection = () => (
    <Container>
        <section className="hero shell" id="sports">
        <div className="hero-copy">
            <h1>
                NBA HISTORY.<br />
                AI SIMULATION.<br />
                <span>REAL ACTION.</span>
            </h1>
            <p>
                We match legendary NBA teams.<br />
                AI simulates every possession.<br />
                You watch, you bet, you win.
            </p>
            <Link to="/signup" className="btn btn-primary btn-large">
                JOIN NOW &amp; START WINNING
            </Link>
            <div className="member">
                Already a member? <Link to="/login">Login to Bet</Link>
            </div>
        </div>
        <div className="hero-art">
            <img
                src={heroMatchup}
                alt="Los Angeles Lakers 2000 versus Chicago Bulls 1996"
            />
        </div>
    </section> </Container>
    
);

export default HeroSection;
